"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ThumbsDown = function ThumbsDown(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    width: '18px',
    height: '18px',
    viewBox: '0 0 23 22',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("g", {
    id: 'Page-1',
    stroke: 'none',
    strokeWidth: '2',
    fill: 'none',
    fillRule: 'evenodd',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }, React.createElement("g", {
    className: 'thumbs thumbs-down ' + className,
    id: 'Icons',
    transform: 'translate(-696.000000, -1104.000000)'
  }, React.createElement("g", {
    id: 'Group-1051',
    transform: 'translate(696.000000, 1104.000000)'
  }, React.createElement("path", {
    d: 'M4,6.5 L4,6.5 C3.172,6.5 2.5,5.828 2.5,5 C2.5,4.172 3.172,3.5 4,3.5 L5,3.5 C4.172,3.5 3.5,2.828 3.5,2 C3.5,1.172 4.172,0.5 5,0.5 L11.5,0.5 C15.5,0.5 14.5,2.37 22.5,2.37 L22.5,11.5 L19.5,11.5 C16,11.5 12,14.656 12,19.436 C12,21.018 9,21.249 9,18.249 C9,16.249 10,12.5 10,12.5 L2,12.5 C1.172,12.5 0.5,11.828 0.5,11 C0.5,10.172 1.172,9.5 2,9.5 L3,9.5 C2.172,9.5 1.5,8.828 1.5,8 C1.5,7.172 2.172,6.5 3,6.5 L4,6.5',
    id: 'Stroke-436'
  })))));
};
exports.ThumbsDown = ThumbsDown;